import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

// Delete customer request
export const deleteCustomerRequest = createAction('[Delete Customer] Delete Customer request', props<{ customerId: string }>());

export const deleteCustomerSuccess = createAction('[Delete Customer] Delete Customer Success', props<{ response: any }>());

export const deleteCustomerFailure = createAction('[Delete Customer] Delete Customer Failure', props<{ error: IGenericError<ErrorResponse> }>());

export const clearDeleteCustomerRequest = createAction('[Delete Customer] Clear Delete Customer request');
